import { t } from 'i18next'

export const ItemTypes = {
  NAMEPLATE: 'nameplate',
  TRIPGRIDCELL: 'tripgridcell',
  ORDERROW: 'orderrow',
  TRAILER_SWAP: 'trailer_swap',
}
export const dropActions = {
  MOVE: 'move',
  INSERT: 'insert',
}
export const shifts = {
  AM: 'am',
  PM: 'pm',
}
export const loadingWindows = {
  NOW: 'now',
  BEFORESIX: 'before 6',
  BEFOREMIDNIGHT: 'before midnight',
  AFTERMIDNIGHT: 'after midnight',
}

export const runoutTimes = {
  NOW: 'now',
  HALFDAY: 'half day',
  DAY: 'next day',
  THREEDAYS: '3 days',
  WEEK: 'week',
}

export const retainTimes = {
  NOW: 'now',
  AMTODAY: 'am today',
  PMTODAY: 'pm today',
  AMTOMORROW: 'am tomorrow',
}
export const dispatchModes = {
  GANTT: 'gantt',
  TRIPGRID: 'tripgrid',
}

export const statusClassDict: Record<string, string> = {
  unset: 'scheduled',
  'driving to load': 'driving',
  'arrived at load': 'arrived-at-load',
  loading: 'loading',
  'arrived at drop': 'arrived-at-drop',
  'driving to drop': 'driving',
  dropping: 'dropping',
  'heading home': 'driving',
  'driving to added stop': 'driving-to-stop',
  'arrived at added stop': 'at-stop',
  'at added stop': 'at-stop',
  complete: 'complete',
  'not delivered': 'not-delivered',
}
export const getTranslateStatus = () => ({
  unset: t('Scheduled'),
  'driving to load': t('Driving To Load'),
  'arrived at load': t('Arrived At Load'),
  loading: t('Loading'),
  'arrived at drop': t('Arrived At Drop'),
  'driving to drop': t('Driving To Drop'),
  preview: t('Preview'),
  dropping: t('Dropping'),
  'heading home': t('Heading Home'),
  'driving to added stop': t('Driving To Added Stop'),
  'arrived at added stop': t('Arrived At Added Stop'),
  'at added stop': t('At Added Stop'),
  complete: t('Completed'),
  'not delivered': t('Not Delivered'),
})
